
<div class="lm-border pa-2 pt-3 pb-3 v-flex" style="position: relative">
    <p-audit-modification
        class  = "escalator-modification"
        :entry = "entry"
    />

    <div style="display: block; width: calc(100% - 30px)" class="pr-0 ml-3">
        <div class="v-flex">
            <div class="catalogue-id">
                {{ code }}
            </div>

            <div
                class  = "catalogue-type ml-2"
                :class = "typeColor"
            >
                {{ entry.type ? entry.type.name : '---' }}
            </div>

            <v-spacer />
            <div class="v-flex" v-if="editable && isPlaner">
                <c-toolbar-button
                    color    = "primary"
                    size     = "20"
                    :icon    = "edit ? 'mdi-content-save' : 'mdi-pencil'"
                    :tooltip = "edit ? $t('audit.escalator.save') : $t('audit.escalator.edit')"
                    @click   = "onEdit"
                />

                <div class="ml-2">
                    <c-toolbar-button
                        v-if     = "edit"
                        color    = "primary"
                        size     = "28"
                        icon     = "mdi-close"
                        :tooltip = "$t('audit.escalator.cancel')"
                        @click   = "onCancel"
                    />
                </div>
            </div>
        </div>

        <v-divider class="mt-2 mb-2" />
        <div v-html="entryTitle"></div>

        <div
            v-if  = "measures.length > 0"
            class = "mt-3 mb-3 lm-border pa-3 pt-2"
        >
            <div class="v-flex mb-3" style="justify-content: center">
                <div>
                    <div class="value-label primary--text">{{ $t('audit.escalator.risk') }}</div>
                    <div class="catalogue-value lm-border">{{ risk ? risk.name : '---' }}</div>
                </div>
                <div class="ml-2">
                    <div class="value-label primary--text">{{ $t('audit.escalator.frequence') }}</div>
                    <div class="catalogue-value lm-border">{{ effective.frequence ? effective.frequence.name : '---' }}</div>
                </div>
                <div class="ml-2">
                    <div class="value-label primary--text">{{ $t('audit.escalator.weight') }}</div>
                    <div class="catalogue-value lm-border">{{ effective.weight ? effective.weight.name : '---' }}</div>
                </div>
            </div>

            <div class="primary--text mb-1" style="font-size: 11px">
                {{ $t('audit.escalator.measures') }}
            </div>

            <div
                v-for = "measure in measures"
                :key  = "'m_' + measure.id"
                class = "v-flex measure-row"
                :class = "measure.chosen ? '' : 'measure-not-chosen'"
            >
                <v-icon
                    size   = "18"
                    :color = "measure.chosen ? 'primary' : 'grey'"
                    :title = "measure.chosen ? $t('audit.escalator.chosen') : $t('audit.escalator.notChosen')"
                >
                    {{ measure.chosen ? 'mdi-checkbox-marked-circle' : 'mdi-checkbox-blank-circle-outline' }}
                </v-icon>

                <!-- neutral chip without colour, as in the app (HCIT-1193) -->
                <div class="measure-kind ml-2 grey lighten-3" v-if="measure.kind">
                    {{ $t('audit.escalator.kind.' + measure.kind) }}
                </div>

                <div class="ml-2 measure-text">
                    <div>
                        {{ measure.description }}
                        <span v-if="measure.deleted" class="grey--text">({{ $t('audit.escalator.deleted') }})</span>
                    </div>
                    <div class="measure-values grey--text text--darken-1">
                        {{ $t('audit.escalator.frequence') }}: {{ measure.frequence ? measure.frequence.name : '---' }}
                        · {{ $t('audit.escalator.weight') }}: {{ measure.weight ? measure.weight.name : '---' }}
                    </div>
                </div>
            </div>

            <v-switch
                v-if      = "editable"
                v-model   = "done"
                :label    = "$t('audit.escalator.done')"
                :ripple   = "false"
                :readonly = "!edit"
                class     = "mt-2"
                hide-details
            />
        </div>

        <div>
            <f-read-only-field
                v-if   = "!edit"
                class  = "mt-2"
                :label = "$t('audit.escalator.note')"
                :value = "entry.notice"
                filled
                dense
            />
            <v-textarea
                v-if    = "edit"
                v-model = "notice"
                :label  = "$t('audit.escalator.note')"
                class   = "mt-4"
                rows    = "2"
                hide-details
                no-resize
            />
        </div>
    </div>
</div>
